module.exports = __webpack_public_path__ + "img/busquedapract.aa27c3d2.png";